import * as yup from 'yup';
export const meddiYup = {
	select: () => {
		return yup.object().shape({
			label: yup.string(),
			value: yup.string(),
		});
	},
	selectRequired: (errorMessage: string) => {
		return yup
			.object()
			.shape({
				label: yup.string(),
				value: yup.string(),
			})
			.test('is-required-select', errorMessage, value => {
				const selectValue = typeof value === 'object' ? value?.value : value;
				return selectValue !== null && typeof selectValue !== 'undefined';
			});
	},
};
